import { render, staticRenderFns } from "./localForm.vue?vue&type=template&id=a6579f8c&scoped=true&"
import script from "./localForm.vue?vue&type=script&lang=ts&"
export * from "./localForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6579f8c",
  null
  
)

export default component.exports